import { Container } from "./styles";

const Background = () => {
    return <Container src={`/assets/heat-background.png`} />;
};

export default Background;
